import { object } from 'yup';
import { validatePassword } from 'lib/utils/inputValidation';
import { UpdatePasswordFields } from './types';

export const updatePasswordValidation = object().shape({
  [UpdatePasswordFields.password]: validatePassword
});
